
<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix">
      <div id="main_area">
        <div class="information">
          <h3>{{ pageData.MenuName }}</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td>申報年度：</td>
                  <td>
                    <select v-model="form.syear">
                      <option
                        v-for="(data, index) in dropDownList.syears"
                        :key="index"
                        :value="data"
                      >
                        {{ data }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>服務機關：</td>
                  <td colspan="3">
                    <select
                      v-model="form.jobGovCode1"
                      style="min-width: 200px"
                      @change="JobGovCode1Change()"
                       :disabled="
                      loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      1 <= loginInfo.layerNum
                    "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode1s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode2"
                      style="min-width: 200px"
                      @change="JobGovCode2Change()"
                       :disabled="
                      (loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      2 <= loginInfo.layerNum) && (loginInfo.govCode != '355010000I' && loginInfo.govCode != 'A11100000F' )
                    "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode2s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode3"
                      style="min-width: 200px"
                      @change="JobGovCode3Change()"
                       :disabled="
                      (loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      3 <= loginInfo.layerNum) && (loginInfo.govCode != '355010000I' && loginInfo.govCode != 'A11100000F' )
                    "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode3s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode4"
                      style="min-width: 200px"
                       :disabled="
                      (loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      4 <= loginInfo.layerNum) && (loginInfo.govCode != '355010000I' && loginInfo.govCode != 'A11100000F' )
                    "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode4s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <div>
                      <input
                        type="checkbox"
                        v-model="form.jobGovCheck"
                        true-value="1"
                        false-value="0"
                      />
                      包含所屬機關
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>受理申報機關：</td>
                  <td colspan="3">
                    <select
                      v-model="form.govCode1"
                      style="min-width: 200px"
                      @change="GovCode1Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        1 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.govCode1s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.govCode2"
                      style="min-width: 200px"
                      @change="GovCode2Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        2 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.govCode2s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.govCode3"
                      style="min-width: 200px"
                      @change="GovCode3Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        3 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.govCode3s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.govCode4"
                      style="min-width: 200px"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        4 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.govCode4s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <div>
                      <input
                        type="checkbox"
                        v-model="form.govCheck"
                        true-value="1"
                        false-value="0"
                      />
                      包含所屬機關
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>身分證統一編號：</td>
                  <td>
                    <input type="text" maxlength="10" v-model="form.idn" />
                  </td>
                  <td>姓名：</td>
                  <td>
                    <input type="text" maxlength="10" v-model="form.name" />
                  </td>
                </tr>
                <tr>
                  <td
                    align="center"
                    colspan="4"
                    style="text-align: center"
                    class="f_center"
                  >
                    <button
                      class="btn"
                      @click="
                        () => {
                          this.form.currentpage = 1;
                          this.form.pagesize = 10;
                          this.doQuery();
                        }
                      "
                    >
                      查 詢
                    </button>
                    <button class="btn" @click="doClear()">重 填</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 查詢結果開始-->
        <div class="information">
          <table width="100%" v-if="grid.gridDatas">
            <tbody>
              <tr>
                <td></td>
                <td align="right" v-if="grid.paginaiton">
                  <input
                    type="button"
                    value="<<"
                    class="btn"
                    style="height: 28px"
                    @click="form.currentpage = grid.paginaiton.pageNo - 1"
                    v-show="grid.paginaiton.pageNo > 1"
                  />
                  <span
                    v-for="(data, index) in grid.paginaiton.pages"
                    :key="index"
                    style="cursor: pointer"
                    :style="
                      grid.paginaiton.pageNo == data
                        ? 'color:red'
                        : 'color:black'
                    "
                    @click="form.currentpage = parseInt(data)"
                  >
                    {{
                      grid.paginaiton.pageNo == data ? "[" + data + "]" : data
                    }}
                  </span>
                  <input
                    type="button"
                    class="btn"
                    value=">>"
                    style="height: 28px"
                    v-show="grid.paginaiton.pageNo < grid.paginaiton.totalPage"
                    @click="form.currentpage = grid.paginaiton.pageNo + 1"
                  />
                  ［每頁<input
                    type="text"
                    v-model.number.lazy="form.pagesize"
                    size="2"
                    maxlength="4"
                  />

                  <input type="button" class="btn" value="筆" />，第<input
                    type="text"
                    v-model.number.lazy="form.currentpage"
                    size="2"
                    maxlength="4"
                  />
                  <input type="button" class="btn" value="頁" />，共
                  {{ grid.paginaiton.totalPage }} 頁
                  {{ grid.paginaiton.totalCount }} 筆］
                </td>
              </tr>
            </tbody>
          </table>
          <div class="active">
            <div class="table_scroll2">
              <table width="1060" class="itable" style="text-align: center">
                <thead>
                  <tr>
                    <th style="min-width: 100px">操作</th>
                    <th style="min-width: 80px">
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('NAME', Sort);
                          }
                        "
                      >
                        姓名</u
                      >
                    </th>
                    <th style="min-width: 100px">
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('JOB_GOV_CODE', Sort);
                          }
                        "
                        >服務機關</u
                      >
                    </th>
                    <th style="min-width: 100px">
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('GOV_CODE', Sort);
                          }
                        "
                        >受理申報機關</u
                      >
                    </th>
                  </tr>
                </thead>
                <tbody v-if="grid.gridDatas && grid.gridDatas.length > 0">
                  <tr v-for="(data, index) in grid.gridDatas" :key="index">
                    <td>
                      <input
                        type="button"
                        class="btn"
                        value="上傳紀錄"
                        @click="doDetail(data)"
                      />
                    </td>
                    <td>{{ data.name }}</td>
                    <td>{{ data.goV_CODE_NAME }}</td>
                    <td>{{ data.radmiN_NAME }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="4">查無資料</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 查詢結果結束-->
        </div>
      </div>
      <!-- 頁籤結束 -->
    </div>
    <PdisFooter />

    <DetailModal
      v-model="DetailModal.show"
      :title="DetailModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div
        class="information"
        v-if="DetailModal.grid && DetailModal.grid.gridDatas"
      >
        <label style="color: red" v-if="DetailModal.grid.gridDatas.length == 0"
          >無上傳紀錄</label
        >
        <table width="100%">
          <tbody>
            <tr>
              <td></td>
              <td align="right" v-if="DetailModal.grid.paginaiton">
                <input
                  type="button"
                  value="<<"
                  class="btn"
                  style="height: 28px"
                  @click="
                    DetailModal.form.currentpage =
                      DetailModal.grid.paginaiton.pageNo - 1
                  "
                  v-show="DetailModal.grid.paginaiton.pageNo > 1"
                />
                <span
                  v-for="(data, index) in DetailModal.grid.paginaiton.pages"
                  :key="index"
                  style="cursor: pointer"
                  :style="
                    DetailModal.grid.paginaiton.pageNo == data
                      ? 'color:red'
                      : 'color:black'
                  "
                  @click="DetailModal.form.currentpage = parseInt(data)"
                >
                  {{
                    DetailModal.grid.paginaiton.pageNo == data
                      ? "[" + data + "]"
                      : data
                  }}
                </span>
                <input
                  type="button"
                  class="btn"
                  value=">>"
                  style="height: 28px"
                  v-show="
                    DetailModal.grid.paginaiton.pageNo <
                    DetailModal.grid.paginaiton.totalPage
                  "
                  @click="
                    DetailModal.form.currentpage =
                      DetailModal.grid.paginaiton.pageNo + 1
                  "
                />
                ［每頁<input
                  type="text"
                  v-model.number.lazy="DetailModal.form.pagesize"
                  size="2"
                  maxlength="4"
                />

                <input type="button" class="btn" value="筆" />，第<input
                  type="text"
                  v-model.number.lazy="DetailModal.form.currentpage"
                  size="2"
                  maxlength="4"
                />
                <input type="button" class="btn" value="頁" />，共
                {{ DetailModal.grid.paginaiton.totalPage }} 頁
                {{ DetailModal.grid.paginaiton.totalCount }} 筆］
              </td>
            </tr>
          </tbody>
        </table>
        <div class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th style="min-width: 450px">操作</th>
                  <th>姓名</th>
                  <th>身分證字號</th>
                  <th>受理申報單位</th>
                  <th>申報日期</th>
                  <th>上傳時間</th>
                  <th>申報序號</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in DetailModal.grid.gridDatas"
                  :key="index"
                >
                  <td width="30%" align="center">
                    <input
                      type="button"
                      class="btn"
                      value="瀏覽申報表"
                      @click="DetailModalDoPrint(data)"
                      v-if="data.alias == '' && data.isdata != 'N'"
                    />
                    <input
                      type="button"
                      class="btn"
                      value="瀏覽申報表(民眾查詢列印)"
                      @click="DetailModalDoPrintHidden(data)"
                      v-if="data.alias == '' && data.isdata != 'N'"
                    />
                    <input
                      type="button"
                      class="btn"
                      value="瀏覽申報表(紙本申報)"
                      @click="DetailUploadPrint(data)"
                      v-if="data.alias != '' && data.isdata != 'N'"
                    />
                    <input
                      type="button"
                      class="btn"
                      value="未有上傳資料"
                      disabled
                      v-if="data.isdata == 'N'"
                    />
                  </td>
                  <td>{{ data.name }}</td>
                  <td>{{ data.idn }}</td>
                  <td>{{ data.radmiN_NAME }}</td>
                  <td>{{ data.sdate }}</td>
                  <td>{{ data.datetimestr }}</td>
                  <td>{{ data.seqno }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- 查詢結果結束-->
      </div>
    </DetailModal>

    <Alert v-model="Alert.show" :title="Alert.title">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import PdisFooter from "@/components/Common/PdisFooter.vue";
import { getMenuIndex } from "@/config/util.js";
import { getMenu, logOut } from "@/config/util.js";
import {
  SearchGovCode,
  B104_SearchGrid,
  B104_ReSearchGrid,
  B104_SearchGridDetail,
  PrintPdisReport,
  PrintPdisHideReport,
  B101_UploadReport,
  UploadReportOld,
  USR_ACT_LOG,
} from "@/service/api.js";
export default {
  name: "B104",
  data: function () {
    return {
      pageData: {
        MenuIndex: 2,
        MenuName: "",
        PrgName: "B104",
        ServiceUnit: "PDIS",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      SessionGovCode: sessionStorage.getItem("Session_GovCode"),
      Order: "",
      Sort: "",
      form: {
        syear: "099",
        govCode1: "",
        govCode2: "",
        govCode3: "",
        govCode4: "",
        govCheck: "1",
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        jobGovCheck: "0",
        idn: "",
        name: "",
        currentpage: 1,
        pagesize: 10,
      },
      dropDownList: {
        syears: [],
        govCode1s: [],
        govCode2s: [],
        govCode3s: [],
        govCode4s: [],
        jobGovCode1s: [],
        jobGovCode2s: [],
        jobGovCode3s: [],
        jobGovCode4s: [],
      },
      grid: {},
      DetailModal: {
        show: false,
        title: "申報資料明細查詢",
        PreData: {},
        grid: {},
        form: {
          currentpage: 1,
          pagesize: 10,
        },
      },
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    PdisFooter,
    DetailModal: VueModal,
    Alert: VueModal,
  },
  methods: {
    getSyearDropDownList: function () {
      let syears = [];
      const startYear = 99; //民國99年
      for (let i = startYear; i <= new Date().getFullYear() - 1911 - 5; i++) {
        syears.push(i.toString().length === 2 ? "0" + i : i.toString());
      }
      return syears;
    },
    //取得服務機關第一層類別
    getSearchGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode1s = rData.returnObject;
      });
    },
    //取得服務機關第二層類別
    getSearchGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode2s = rData.returnObject;
      });
    },
    //取得服務機關第三層類別
    getSearchGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode3s = rData.returnObject;
      });
    },
    //取得服務機關第四層類別
    getSearchGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode4s = rData.returnObject;
      });
    },
    //取得受理申報機關第一層類別
    getSearchJobGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode1s = rData.returnObject;
      });
    },
    //取得受理申報機關第二層類別
    getSearchJobGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        if(self.loginInfo.govCode == '355010000I')
        {
          self.dropDownList.jobGovCode2s = rData.returnObject.filter(x=>x.value == '355010000I' || x.value == '355020000I');
        }
        else if(self.loginInfo.govCode == 'A11100000F')
        {
          self.dropDownList.jobGovCode2s = rData.returnObject.filter(x=>x.value == 'A11100000F' || x.value == 'A11000600F');
        }
        else
        {
          self.dropDownList.jobGovCode2s = rData.returnObject;
        }
      });
    },
    //取得受理申報機關第三層類別
    getSearchJobGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode3s = rData.returnObject;
      });
    },
    //取得受理申報機關第四層類別
    getSearchJobGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode4s = rData.returnObject;
      });
    },
    //第一頁查詢
    doQuery: function () {
      const self = this;
       //清空
      self.Order = "";
      self.Sort = "";
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        syear: self.form.syear,
        idn: self.form.idn,
        name: self.form.name,
        gov: self.form.govCode4
          ? self.form.govCode4
          : self.form.govCode3
          ? self.form.govCode3
          : self.form.govCode2
          ? self.form.govCode2
          : self.form.govCode1
          ? self.form.govCode1
          : "",
        govcheck: parseInt(self.form.govCheck),
        jobgov: self.form.jobGovCode4
          ? self.form.jobGovCode4
          : self.form.jobGovCode3
          ? self.form.jobGovCode3
          : self.form.jobGovCode2
          ? self.form.jobGovCode2
          : self.form.jobGovCode1
          ? self.form.jobGovCode1
          : "",
        jobgovcheck: parseInt(self.form.jobGovCheck),
        currentpage: self.form.currentpage,
        pagesize: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      console.log(JSON.stringify(postData));
      B104_SearchGrid(postData).then((rData) => {
        if(rData.result){
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit,self);
          };
        }
      });
    },
    reQuery: function (NM, SC) {
      const self = this;
      if (NM == "" && SC == "") {
        if (self.Order == "" && self.Sort == "") {
          //所謂預設值
          self.Order = "GOV_CODE";
          self.Sort = "ASC";
        } else {
          //換頁 self.Order && self.Sort 維持原樣
        }
      } else if (NM == self.Order) {
        //而後的點擊
        if (SC == "ASC") {
          self.Sort = "DESC";
        } else {
          self.Sort = "ASC";
        }
      } else {
        //第一次的點擊
        self.Order = NM;
        self.Sort = "ASC";
      }

      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        syear: self.form.syear,
        idn: self.form.idn,
        name: self.form.name,
        gov: self.form.govCode4
          ? self.form.govCode4
          : self.form.govCode3
          ? self.form.govCode3
          : self.form.govCode2
          ? self.form.govCode2
          : self.form.govCode1
          ? self.form.govCode1
          : "",
        govcheck: parseInt(self.form.govCheck),
        jobgov: self.form.jobGovCode4
          ? self.form.jobGovCode4
          : self.form.jobGovCode3
          ? self.form.jobGovCode3
          : self.form.jobGovCode2
          ? self.form.jobGovCode2
          : self.form.jobGovCode1
          ? self.form.jobGovCode1
          : "",
        jobgovcheck: parseInt(self.form.jobGovCheck),
        currentpage: self.form.currentpage,
        pagesize: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
        SORT: self.Sort,
        ORDER: self.Order,
      };
      console.log(JSON.stringify(postData));
      B104_ReSearchGrid(postData).then((rData) => {
        if(rData.result){
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit,self);
          };
        }
      });
    },
    //第一頁 重填
    doClear: function () {
      const self = this;
      self.form = {
        syear: "099",
        govCode1: "",
        govCode2: "",
        govCode3: "",
        govCode4: "",
        govCheck: "1",
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        jobGovCheck: "0",
        idn: "",
        name: "",
        currentpage: 1,
        pagesize: 10,
      };
      self.JobGovCodeInit(self.form);
      self.getSearchJobGovCode1();
      self.GovCodeInit(self.form);
      self.getSearchGovCode1();
    },
    GovCodeInit: function (form) {
      const self = this;
      if (self.SessionGovCode != null) {
        form.govCode1 = self.SessionGovCode;
        form.govCode2 = "";
        form.govCode3 = "";
        form.govCode4 = "";
      } else {
        if (self.loginInfo) {
          let govCodeArray = self.loginInfo.govCodeStr.split(",");
          form.govCode1 = govCodeArray[0];
          form.govCode2 = govCodeArray[1];
          form.govCode3 = govCodeArray[2];
          form.govCode4 = govCodeArray[3];
        }
      }
    },
    GovCode1Change: function () {
      const self = this;
      self.form.govCode2 = "";
      self.form.govCode3 = "";
      self.form.govCode4 = "";
      self.dropDownList.govCode2s = [];
      self.dropDownList.govCode3s = [];
      self.dropDownList.govCode4s = [];
    },
    GovCode2Change: function () {
      const self = this;
      self.form.govCode3 = "";
      self.form.govCode4 = "";
      self.dropDownList.govCode3s = [];
      self.dropDownList.govCode4s = [];
    },
    GovCode3Change: function () {
      const self = this;
      self.form.govCode4 = "";
      self.dropDownList.govCode4s = [];
    },
    JobGovCodeInit: function (form) {
      const self = this;
      if (self.SessionGovCode != null) {
        form.jobGovCode1 = self.SessionGovCode;
        form.jobGovCode2 = "";
        form.jobGovCode3 = "";
        form.jobGovCode4 = "";
      } else {
        if (self.loginInfo) {
          let govCodeArray = self.loginInfo.govCodeStr.split(",");
          form.jobGovCode1 = govCodeArray[0];
          form.jobGovCode2 = govCodeArray[1];
          form.jobGovCode3 = govCodeArray[2];
          form.jobGovCode4 = govCodeArray[3];
        }
      }
    },
    JobGovCode1Change: function () {
      const self = this;
      self.form.jobGovCode2 = "";
      self.form.jobGovCode3 = "";
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode2s = [];
      self.dropDownList.jobGovCode3s = [];
      self.dropDownList.jobGovCode4s = [];
    },
    JobGovCode2Change: function () {
      const self = this;
      self.form.jobGovCode3 = "";
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode3s = [];
      self.dropDownList.jobGovCode4s = [];
    },
    JobGovCode3Change: function () {
      const self = this;
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode4s = [];
    },
    //第一頁 紀錄
    doDetail: function (data) {
      const self = this;
      self.DetailModal.show = true;
      self.DetailModal.PreData = data;
      self.DetailModal.form.currentpage = 1;
      self.DetailModal.form.pagesize = 10;
      self.B104_SearchGridDetail();
    },
    //Detail資料
    B104_SearchGridDetail: function () {
      const self = this;
      if (
        !self.checkPage(
          self.DetailModal.form.currentpage,
          self.DetailModal.form.pagesize
        )
      )
        return;
      let postData = {
        syear: self.form.syear,
        seqno: self.DetailModal.PreData.seqno,
        idn: self.DetailModal.PreData.idn,
        gov: self.DetailModal.PreData.goV_CODE,
        currentpage: self.DetailModal.form.currentpage,
        pagesize: self.DetailModal.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "上傳紀錄",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      B104_SearchGridDetail(postData).then((rData) => {
        if(rData.result){
          self.DetailModal.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit,self);
          };
        }
      });
    },
    //第二頁瀏覽申報表
    DetailModalDoPrint: function (data) {
      const self = this;

      //2025-02-20新增執行按鈕寫Log
      let usr_act_log = {
        Id: self.loginInfo.id,
        PrgCode: 'B104',
        ActCd: '瀏覽申報表',
        FunName: 'DetailModalDoPrint',
        ServiceUnit: self.pageData.ServiceUnit,
        Log: '姓名: ' + data.name + ', seqno: ' + data.seqno,
      };
      USR_ACT_LOG(usr_act_log);

      let postData = {
        serviceUnit: "PDIS",
        seqno: data.seqno,
        printType: "R",
        unit: "",
      };
      PrintPdisReport(postData).then((rData) => {
        let link = document.createElement("a");
        link.download =
          new Date().toISOString().slice(0, 10).replace(/-/g, "") +
          "公職人員財產申報表";
        link.href = "data:application/pdf;base64," + rData;
        link.click();
      });
    },
    //第二頁瀏覽申報表(民眾查詢列印)
    DetailModalDoPrintHidden: function (data) {
      const self = this;

      //2025-02-20新增執行按鈕寫Log
      let usr_act_log = {
        Id: self.loginInfo.id,
        PrgCode: 'B104',
        ActCd: '瀏覽申報表(民眾查詢列印)',
        FunName: 'DetailModalDoPrintHidden',
        ServiceUnit: self.pageData.ServiceUnit,
        Log: '姓名: ' + data.name + ', seqno: ' + data.seqno,
      };
      USR_ACT_LOG(usr_act_log);

      let postData = {
        serviceUnit: "PDIS",
        seqno: data.seqno,
        printType: "R",
      };
      PrintPdisHideReport(postData).then((rData) => {
        let link = document.createElement("a");
        link.download =
          new Date().toISOString().slice(0, 10).replace(/-/g, "") +
          "公職人員財產申報表";
        link.href = "data:application/pdf;base64," + rData;
        link.click();
      });
    },
    //第二頁瀏覽申報表 紙本上傳
    DetailUploadPrint: function (data) {
      const self = this;
      let postData = {
        seqno: data.seqno,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "瀏覽申報表(紙本申報)",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      // console.log(JSON.stringify(postData));
      B101_UploadReport(postData).then((rData) => {
        if (rData.length > 0) {
          let link = document.createElement("a");
          // link.download = "B101紙本申報";
          // link.href =
          //   "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
          //   rData;
          // link.href = "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64," + rData;
          link.download = rData[0].filE_NAME;
          link.href =
            "data:" +
            rData[0].filE_TYPE  +
            ";base64," +
            rData[0].filE_STRING;
          //link.href = rData[0].filE_TYPE + "," + rData[0].filE_STRING;
          link.click();
        } else {
          UploadReportOld(postData).then((rData) => {
            let link = document.createElement("a");
            link.download = rData[0].filE_NAME;
            link.href = rData[0].filE_TYPE + "," + rData[0].filE_STRING;
            link.click();
          });
          // self.Alert.show = true;
          // self.Alert.title = "錯誤";
          // self.Alert.txt = "未取得資料表";
          // self.Alert.txt = rData.messages;
          // self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //分頁防呆檢查
    checkPage: function (currentpage, pagesize) {
      const self = this;
      let pageErrorMsg = [];
      if (currentpage) {
        if (isNaN(parseInt(currentpage))) {
          pageErrorMsg.push("頁數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫頁數");
      }
      if (pagesize) {
        if (isNaN(parseInt(pagesize))) {
          pageErrorMsg.push("筆數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫每頁筆數");
      }
      if (pageErrorMsg.length) {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = pageErrorMsg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
        return false;
      }
      return true;
    },
  },
  watch: {
    "form.jobGovCode1": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode2(newValue);
    },
    "form.jobGovCode2": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode3(newValue);
    },
    "form.jobGovCode3": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode4(newValue);
    },
    "form.govCode1": function (newValue, oldValue) {
      if (newValue != "") this.getSearchGovCode2(newValue);
    },
    "form.govCode2": function (newValue, oldValue) {
      if (newValue != "") this.getSearchGovCode3(newValue);
    },
    "form.govCode3": function (newValue, oldValue) {
      if (newValue != "") this.getSearchGovCode4(newValue);
    },
    "form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
    "form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
       this.reQuery("", "");
      }
    },
    "DetailModal.form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.B104_SearchGridDetail();
      }
    },
    "DetailModal.form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.B104_SearchGridDetail();
      }
    },
  },
  created() {
    const self = this;
    const Menu = getMenu(self.pageData.PrgName);
    //RoleAuthorizeMenu
    if (Menu) {
      self.pageData.MenuIndex = getMenuIndex(self.pageData.PrgName);
      self.pageData.MenuName = Menu.menuName;
    } else {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.GovCodeInit(self.form);
    self.JobGovCodeInit(self.form);
    self.getSearchGovCode1();
    self.getSearchJobGovCode1();
    self.dropDownList.syears = self.getSyearDropDownList();
    self.doQuery();
  },
};
</script>

<style scoped src="@/assets/css/Pdis.css" />
